<template>
  <div class="custom-container" v-if="visible">
    <el-dialog :title="$t('listPage.text.customList')" :visible.sync="boxVisible" :close-on-click-modal="false" :before-close="cancel">
      <!-- <el-alert :title="'请选择要显示在列表的信息，最多选择'+optionArr.length+'个'" type="warning" show-icon :closable="false">
      </el-alert> -->
      <div class="i-text">
        <div class="tip-earlyWarning mb10" style="line-height: 19px" v-if="optionArr.length > 10">
          {{$t('speechCraft.customList')}}
        </div>
      </div>
      <div class="custom-list">
        <el-checkbox-group v-model="currentSelect">
          <div class="custom-list-item" v-for="item in optionArr" :key="item.value">
             <el-checkbox :label="item.value" :disabled="getDisabled(item.value)
              ||(currentSelect.length >= 10 && currentSelect.indexOf(item.value) < 0)">
               {{item.label}}
             </el-checkbox>
            <!--<el-checkbox :label="item.value" :disabled="getDisabled(item.value)">{{item.label}}
            </el-checkbox>-->
          </div>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">{{$t('text.cancel')}}</el-button>
        <el-button type="primary" @click="confirm">{{$t('text.confirm')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    optionArr: {
      type: Array,
      default: []
    },
    type: {
      type: String,
      required: true
    }
  },
  name: "custom",
  created () {
    for (var value in this.customerInfo) {
      if (this.customerInfo[value].selected) {
        this.currentSelect.push(value)
      }
    }
  },
  computed: {
    customerInfo(){
      return this.$store.state.customInfo[this.type]
    }
  },
  data() {
    return {
      boxVisible: this.visible,
      currentSelect: []
    };
  },
  watch: {
    visible(newVal, oldVal) {
      this.boxVisible = newVal
    },
    currentSelect(newVal,oldVal){
      console.log(newVal,oldVal)
    }
  },
  methods: {
    getDisabled (value) {
      if(this.customerInfo[value].required !== undefined) {
         if (this.customerInfo[value].required == true || this.customerInfo[value].required == 'true') {
           return true
         }else {
           return false
         }
      }
      return false
    },
    setParam(){
      var cacheInfo = $.extend(true, {}, this.customerInfo);
      for (var value in cacheInfo) {
        cacheInfo[value].selected = false
      }
      for (var key of this.currentSelect) {
        cacheInfo[key].selected = true
      }
      return  cacheInfo
    },
    confirm() {
      var param = {
        pageKey: this.type,
        pageValue: null
      }
      param.pageValue = this.setParam()
      Ajax.post('/api/usercenter/setCustomInfo', param, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then((res) => {
          const data = res.data;
          console.log(data)
          this.$store.commit('GET_CUSTOMINFO', {value: param.pageValue, type: this.type})
          this.$emit('update:visible', false)
        })
        .catch(async (err) => {
          const {response} = err.data;
          try {
            const json = await response.json();
            this.$message.error(json.errmsg);
          } catch (ex) {
            console.log(ex);
          }
        })
    },
    cancel() {
      this.$emit('update:visible', false)
    }
  }
};
</script>
<style lang="sass">
  @import "./custom"
</style>



// WEBPACK FOOTER //
// src/components/common/custom/Custom.vue